(() => {
  const dialog = document.getElementById('grand-lightbox');
  const largeImage = document.getElementById('grand-lightbox-image');
  const largeTitle = document.getElementById('grand-lightbox-title');
  const largeCount = document.getElementById('grand-lightbox-count');
  let active = null;
  let returnFocus = null;
  function update(carousel, next) {
    const photos = JSON.parse(carousel.dataset.photos);
    const index = ((next % photos.length) + photos.length) % photos.length;
    carousel.dataset.index = String(index);
    const label = `${carousel.dataset.piano} — photo ${index + 1} of ${photos.length}`;
    const photo = carousel.querySelector('.grand-photo-open img');
    photo.src = photos[index]; photo.alt = label;
    carousel.querySelector('.grand-photo-number').textContent = `${index + 1} / ${photos.length}`;
    carousel.querySelectorAll('.grand-dot').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    if (active === carousel && dialog.open) {
      largeImage.src = photos[index]; largeImage.alt = label;
      largeTitle.textContent = carousel.dataset.piano;
      largeCount.textContent = `Photo ${index + 1} of ${photos.length}`;
    }
    const preload = new Image(); preload.src = photos[(index + 1) % photos.length];
  }
  function step(carousel, amount) { update(carousel, Number(carousel.dataset.index) + amount); }
  document.querySelectorAll('.grand-carousel').forEach(carousel => {
    const photos = JSON.parse(carousel.dataset.photos);
    const opener = carousel.querySelector('.grand-photo-open');
    let touchX = null; let touchY = null; let blockClickUntil = 0;
    carousel.querySelector('.grand-prev').addEventListener('click', () => step(carousel, -1));
    carousel.querySelector('.grand-next').addEventListener('click', () => step(carousel, 1));
    carousel.querySelectorAll('.grand-dot').forEach(dot => dot.addEventListener('click', () => update(carousel, Number(dot.dataset.photo))));
    opener.addEventListener('click', () => {
      if (Date.now() < blockClickUntil) return;
      active = carousel; returnFocus = opener; dialog.showModal();
      update(carousel, Number(carousel.dataset.index));
    });
    carousel.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); step(carousel, event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    opener.addEventListener('touchstart', event => {
      if (event.touches.length !== 1) { touchX = null; return; }
      touchX = event.touches[0].clientX; touchY = event.touches[0].clientY;
    }, {passive: true});
    opener.addEventListener('touchend', event => {
      if (touchX === null || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchX;
      const dy = event.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        blockClickUntil = Date.now() + 500; step(carousel, dx < 0 ? 1 : -1);
      }
      touchX = null;
    }, {passive: true});
    opener.addEventListener('touchcancel', () => { touchX = null; }, {passive: true});
    if (photos.length < 2) carousel.querySelectorAll('.grand-arrow,.grand-photo-dots').forEach(el => { el.hidden = true; });
  });
  dialog.querySelector('.grand-lightbox-close').addEventListener('click', () => dialog.close());
  document.getElementById('grand-lightbox-prev').addEventListener('click', () => { if (active) step(active, -1); });
  document.getElementById('grand-lightbox-next').addEventListener('click', () => { if (active) step(active, 1); });
  dialog.addEventListener('keydown', event => {
    if (active && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault(); step(active, event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { active = null; if (returnFocus) returnFocus.focus(); });
})();
